"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRangeEntityLike = exports.RangeEntity = exports.RangeTelVersion = exports.RangeEntityClassName = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const DeviceEnabledType_1 = require("./Device/DeviceEnabledType");
exports.RangeEntityClassName = 'RangeEntity';
var RangeTelVersion;
(function (RangeTelVersion) {
    RangeTelVersion["V2"] = "V2";
    RangeTelVersion["V3_GTV2"] = "V3_GTV2";
    RangeTelVersion["V3"] = "V3";
})(RangeTelVersion || (exports.RangeTelVersion = RangeTelVersion = {}));
/** https://docs.google.com/spreadsheets/d/1HhsMWtMdw5AQ4cXIHG03at20vNMyguhu3B4mEdDYrY4/edit?usp=sharing */
const RadarV2 = {
    start: { min: 60, default: 300, max: 7000 },
    end: { min: 76, default: 7000, max: 7000 },
};
/** https://docs.google.com/spreadsheets/d/1NJG_QiTOiQYi2JivY-GcoY5jYUYOhr-bWmFYZG_pQ1s/edit?usp=sharing */
const RadarV3 = {
    start: { min: 100, default: 300, max: 19900 },
    end: { min: 200, default: 10000, max: 20000 },
};
const Limits = {
    [RangeTelVersion.V2]: RadarV2,
    [RangeTelVersion.V3_GTV2]: RadarV3,
    [RangeTelVersion.V3]: RadarV3,
};
function clamp(min, value, max) {
    return Math.max(min, Math.min(value, max));
}
function processRangeLimit(value, limits) {
    const defined = Math.min(value ?? limits.default);
    return clamp(limits.min, defined, limits.max);
}
class RangeEntity extends DeviceEnabledType_1.DeviceEnabledType {
    constructor(ob) {
        if (ob.type !== undefined && ob.type !== exports.RangeEntityClassName)
            throw new Error(`Tried to create a ${exports.RangeEntityClassName} from a ${ob.type} object!`);
        super(exports.RangeEntityClassName, { ...ob });
        this.deviceVersion = RangeTelVersion.V2;
        this.rangeStart = 300;
        this.rangeEnd = 7000;
        this.type = ob.type ?? exports.RangeEntityClassName;
        this.distance = ob.distance ?? null;
        this.deviceVersion = ob.deviceVersion ?? RangeTelVersion.V2;
        this.rangeStart = processRangeLimit(ob.rangeStart, Limits[this.deviceVersion].start);
        this.rangeEnd = processRangeLimit(ob.rangeEnd, Limits[this.deviceVersion].end);
        this.score_distance = ob.score_distance ?? null;
        this.batteryPercentage = ob.batteryPercentage ?? null;
        this.deviceBatteryVoltage = ob.deviceBatteryVoltage ?? null;
        this.rssi = ob.rssi ?? null;
        this.sf = ob.sf ?? null;
        this.snr = ob.snr ?? null;
        this.fCnt = ob.fCnt ?? null;
        this.deviceEui = ob.deviceEui ?? null;
        this.gatewayEui = ob.gatewayEui ?? null;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                required: true,
                label: 'Name',
                name: 'name',
                description: 'identification',
                validation: { regex: /^[\p{L}0-9\s']+$/u, pass: true, invalidMessage: 'Name cannot contain invalid characters' },
            },
            distance: {
                label: 'Distance',
                type: 'Number',
                units: 'm',
                precision: 3,
                displayFn: (d) => (d ? d / 1000 : d),
                editable: false,
            },
            deviceVersion: {
                label: 'Device Version',
                type: 'Enum',
                enumKv: RangeTelVersion,
                editable: true,
                required: true,
                default: RangeTelVersion.V2,
            },
            rangeStart: {
                label: 'Range Start',
                type: 'Number',
                units: 'm',
                valueFn: (d) => (d ? d * 1000 : d),
                displayFn: (d) => (d ? d / 1000 : d),
                editable: true,
                required: true,
                default: Limits[RangeTelVersion.V2].start.default,
            },
            rangeEnd: {
                label: 'Range End',
                type: 'Number',
                units: 'm',
                valueFn: (d) => (d ? d * 1000 : d),
                displayFn: (d) => (d ? d / 1000 : d),
                editable: true,
                required: true,
                default: Limits[RangeTelVersion.V2].end.default,
            },
        };
    }
}
exports.RangeEntity = RangeEntity;
const isRangeEntityLike = (ob) => {
    return (0, iotv_v3_types_1.isValidBusinessObject)(ob) && ob.type === exports.RangeEntityClassName;
};
exports.isRangeEntityLike = isRangeEntityLike;
